import { render, staticRenderFns } from "./baoxiantwo.vue?vue&type=template&id=6953d1a1&scoped=true"
import script from "./baoxiantwo.vue?vue&type=script&lang=js"
export * from "./baoxiantwo.vue?vue&type=script&lang=js"
import style0 from "./baoxiantwo.vue?vue&type=style&index=0&id=6953d1a1&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953d1a1",
  null
  
)

export default component.exports